import { MyRequestsNavLabel } from "@features/my-requests/components/MyRequestsNavLabel";
import { Link } from "react-router-dom";

const linkClass =
  "grid grid-cols-[max-content_max-content] gap-0.5 items-center border-none bg-none cursor-pointer font-medium transition-all duration-200 ease-in-out hover:scale-110 hover:text-[#f2987a] focus:text-[#f2987a] focus:outline-none";

export const MarketplaceNavLinks = ({
  t,
  checkIfActive,
  navbarTextColor,
  showMyRequestsNav = false,
  showMyRequestsUnread = false,
  navbarBackgroundColor = "#1E3A8A",
  showMyAssets = true,
}) => {
  return (
    <>
      <Link
        to="/products"
        className={`${linkClass} ${
          checkIfActive("/products") ? "text-amber-500" : ""
        }`}
        style={
          !checkIfActive("/products") ? { color: navbarTextColor } : undefined
        }
        data-testid="allProductsNav"
      >
        {t("allProducts")}
      </Link>
      {showMyRequestsNav && (
        <Link
          to="/my-requests"
          className={`${linkClass} ${
            checkIfActive("/my-requests") ? "text-amber-500" : ""
          }`}
          style={
            !checkIfActive("/my-requests")
              ? { color: navbarTextColor }
              : undefined
          }
          data-testid="myRequestsNav"
          aria-label={
            showMyRequestsUnread ? t("myRequestsUnreadAria") : undefined
          }
        >
          <MyRequestsNavLabel
            showNotification={showMyRequestsUnread}
            ringColor={navbarBackgroundColor}
          >
            {t("myRequests")}
          </MyRequestsNavLabel>
        </Link>
      )}
      {showMyAssets ? (
      <Link
        to="/asset-management"
        className={`${linkClass} ${
          checkIfActive("/asset-management") ? "text-amber-500" : ""
        }`}
        style={
          !checkIfActive("/asset-management")
            ? { color: navbarTextColor }
            : undefined
        }
        data-testid="myProductsNav"
      >
        {t("assetManagement")}
      </Link>
      ) : null}
    </>
  );
};
